import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import firebase from 'firebase';

@Component({
  selector: 'app-event',
  templateUrl: './event.page.html',
  styleUrls: ['./event.page.scss'],
})
export class EventPage implements OnInit {

  eventList = [];

  slideOpts = {
    initialSlide: 0,
    direction: 'horizontal',
    spaceBetween: 50,
    slidesPerView: 1,
    centeredSlides: true, 
    speed: 400,
    autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          stopOnLastSlide: true
    }
  };


  constructor(public viewCtrl: ModalController) { }

  ngOnInit() {
    firebase.database().ref('event').on('value', data => {
      this.eventList = data.val()
      console.log(this.eventList);
    })
  }

  dismiss(){
    this.viewCtrl.dismiss()
  }
}
